import { withInstall } from '../../utils/install';
import BackTop from './index.vue';

export const IvueBackTop = withInstall(BackTop);
export default IvueBackTop;

export * from './index.vue';
